module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading) ? _c('loading') : _c('div', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "aggregate"
  }, [_vm._l((_vm.students), function(student) {
    return _c('table', {
      staticClass: "aggregate__student"
    }, [_c('thead', [_c('tr', {
      staticClass: "aggregate__header aggregate__header--print"
    }, [_c('th', [_c('h4', {
      staticClass: "tag"
    }, [_vm._v("Kiempunt overzicht klas " + _vm._s(_vm.group.name) + " - " + _vm._s(_vm.username(student)) + " - " + _vm._s(_vm.currentDate))])])])]), _c('tbody', [_c('tr', {
      staticClass: "aggregate__header aggregate__header--title"
    }, [_c('th', [_c('hr'), _c('h1', [_vm._v(_vm._s(_vm.username(student)))])])]), _vm._l((_vm.assignments), function(assignment) {
      return _c('tr', {
        staticClass: "aggregate__assignment"
      }, [_c('td', [_c('div', {
        staticClass: "aggregate__assignment-wrap"
      }, [_c('h2', [_vm._v(_vm._s(assignment.title))]), _c('assignment-progress', {
        attrs: {
          "progress": _vm.progressForStudentAndAssignment(student, assignment, _vm.group)
        }
      })], 1)])])
    })], 2)])
  }), _c('img', {
    staticClass: "dummy-image",
    attrs: {
      "src": ""
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6301878e","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/students/Aggregate.vue
// module id = 2omD
// module chunks = 1